module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.readonly) ? _c('mt-cell', {
    attrs: {
      "title": _vm.label,
      "readonly": _vm.readonly,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    }
  }, [_c('div', {
    staticClass: "em-select-value mt-color-grey-lv3"
  }, [
    [_vm._v(_vm._s(_vm.selectedDisplayValue))]
  ], 2)]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('mt-cell', {
    attrs: {
      "title": _vm.label,
      "is-link": "",
      "disabledcolor": _vm.disabled,
      "required": _vm.required,
      "titlewidth": _vm.titlewidth,
      "value-align": _vm.textalign
    },
    nativeOn: {
      "click": function($event) {
        _vm.handleDisplayClick($event)
      }
    }
  }, [_c('span', {
    class: [{
      'mt-color-grey-lv3': _vm.selectedDisplayValue === '请选择',
      'aabb': true
    }],
    staticStyle: {
      "lineHeight": "initial"
    }
  }, [_vm._v(_vm._s(_vm.selectedDisplayValue))])]) : _vm._e(), _vm._v(" "), (!_vm.readonly) ? _c('bs-transition-page', {
    model: {
      value: (_vm.selectorShow),
      callback: function($$v) {
        _vm.selectorShow = $$v
      },
      expression: "selectorShow"
    }
  }, [(_vm.search) ? _c('mt-search', {
    attrs: {
      "placeholder": "请输入关键字"
    },
    model: {
      value: (_vm.searchKey),
      callback: function($$v) {
        _vm.searchKey = $$v
      },
      expression: "searchKey"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectType === 'select') ? [_c('mt-box-group', {
    style: ({
      overflow: 'auto',
      height: _vm.radiolistHeight + 'px'
    }),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [_c('mt-cell-group', [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "false",
      "infinite-scroll-distance": "10"
    }
  }, _vm._l((_vm.selectOptions), function(item) {
    return _c('mt-radiobox', {
      key: item.value,
      attrs: {
        "name": item.value,
        "disabled": item.disabled
      },
      nativeOn: {
        "change": function($event) {
          _vm.handleClickSelect($event)
        }
      }
    }, [_vm._v(_vm._s(item.label))])
  }))])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('mt-button', {
    attrs: {
      "size": "large",
      "type": "default"
    },
    on: {
      "click": _vm.goback
    }
  }, [_vm._v("返回")])], 1)] : (_vm.selectType === 'multi-select') ? [_c('mt-box-group', {
    style: ({
      overflow: 'auto',
      height: _vm.checklistHeight + 'px'
    }),
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  }, [_c('mt-cell-group', [_c('div', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "false",
      "infinite-scroll-distance": "footerHeight + 10"
    }
  }, _vm._l((_vm.selectOptions), function(item) {
    return _c('mt-checkbox', {
      key: item.value,
      attrs: {
        "name": item.value,
        "disabled": item.disabled
      }
    }, [_vm._v("\n                            " + _vm._s(item.label) + "\n                        ")])
  }))])], 1), _vm._v(" "), _c('base-selected-footer', {
    attrs: {
      "options": _vm.options
    },
    on: {
      "confirm-click": _vm.handleConfirm
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })] : _vm._e()], 2) : _vm._e()], 1)
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./src/components/emapm-form/baseComponents/baseSelect/baseSelect.vue